var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('px-custom-dialog',{attrs:{"transition":"fadet","width":"900"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,{"on":on})]}}],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('px-resposta-negociacao',{attrs:{"resposta":_vm.resposta,"dialog":_vm.dialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }